import React, { useState, useEffect, useContext } from 'react';
import Xarrow, { useXarrow, Xwrapper } from 'react-xarrows';
import ResizableRect from 'react-resizable-rotatable-draggable';
import MyContext from '../../context/MyContext';
import { Tooltip } from 'react-tippy';
const CanvasOverlay = ({ AtoZ, setAtoZ }) => {

    const { setLayersData, LayersData, clone } = useContext(MyContext)

    const props = {
        start: 'box1',
        end: 'box2',
        curveness: 0,
        dashness: true
    };
    const RemoveAtoZ = () => {
        if (AtoZ.length != 0) {
            let data;
            if (AtoZ[0].BoxId == 'box1') {
                data = clone(AtoZ[0])
            }
            else if (AtoZ[1].BoxId == 'box1') {
                data = clone(AtoZ[1])
            }
            const array = Array.from(LayersData);
            for (let i = 0; i < array.length; i++) {
                if (array[i].key === data.key) {
                    array[i].AzData = null
                    break
                }
            }
            setLayersData(array);
            setAtoZ([]);
        }
    }

    const Savetolayer = () => {
        if (AtoZ.length != 0) {
            if (AtoZ[0].BoxId == 'box1') {
                let data = clone(AtoZ[0])
                data.AzData = clone(AtoZ[1])
                data.originalX = data.x;
                data.originalY = data.y;
                data.originalWidth = data.width;
                data.originalHeight = data.height;
                data.originalOpacity = data.opacity;
                data.originalRotateAngle = data.rotateAngle;

                if (data.type == "text") {
                    data.originalFontSize = data.fontSize;
                    data.originalText = data.text;
                }

                const array = Array.from(LayersData);

                for (let i = 0; i < array.length; i++) {
                    if (array[i].key === data.key) {
                        array[i] = data
                        break
                    }
                }

                setLayersData(array);

            }
            else if (AtoZ[1].BoxId == 'box1') {

                let data = clone(AtoZ[1])
                data.AzData = clone(AtoZ[0])
                data.originalX = data.x;
                data.originalY = data.y;
                data.originalWidth = data.width;
                data.originalHeight = data.height;
                data.originalOpacity = data.opacity;
                data.originalRotateAngle = data.rotateAngle;

                if (data.type == "text") {
                    data.originalFontSize = data.fontSize;
                    data.originalText = data.text;
                }

                const array = Array.from(LayersData);
                for (let i = 0; i < array.length; i++) {
                    if (array[i].key === data.key) {
                        array[i] = data
                        break
                    }
                }
                setLayersData(array);
            }
            setAtoZ([])
        }
    }
   

    return (
        <>
            <div className='CanvasOverLay' onClick={(e) => { if (e.target.className == 'CanvasOverLay') { Savetolayer() } }}>
                <Tooltip
                    title="Delete A-Z"
                    position="left-end"
                    trigger="mouseenter"
                    theme='transparent'
                    arrow={true}
                    animation='scale'
                    style={{
                        position: 'absolute',
                        top: '7px',
                        right: '7px'
                    }}
                >
                    <span class="material-icons del-CanvasOvrelay" onClick={RemoveAtoZ}>
                        delete
                    </span>
                </Tooltip>
                <Xwrapper>
                    {/* {AtoZ.map((value) => {
                    return (<>
                        <DraggableBox id={value.BoxId} box={value} boxdata={AtoZ} setboxdata={setAtoZ} />
                    </>)
                })} */}

                    <DraggableBox id={AtoZ[0].BoxId} box={AtoZ[0]} data={AtoZ[0]} boxdata={AtoZ} setboxdata={setAtoZ} top={AtoZ[0].y} left={AtoZ[0].x} width={AtoZ[0].width} height={AtoZ[0].height} rotate={AtoZ[0].rotateAngle} />

                    <DraggableBox id={AtoZ[1].BoxId} box={AtoZ[1]} data={AtoZ[0]} boxdata={AtoZ} setboxdata={setAtoZ} top={AtoZ[1].y} left={AtoZ[1].x} width={AtoZ[1].width} height={AtoZ[1].height} rotate={AtoZ[1].rotateAngle} />

                    <Xarrow {...props} />

                </Xwrapper>
            </div>
        </>
    );
};

const DraggableBox = ({ id, box, setboxdata, data, boxdata, top, left, width, height, rotate }) => {

    const [resize, setresize] = useState({
        top: Math.round(top),
        left: Math.round(left),
        width: Math.round(width),
        height: Math.round(height),
        rotateAngle: rotate,
    })

    const Drag = (deltaX, deltaY) => {
        setresize({ ...resize, left: resize.left + deltaX, top: resize.top + deltaY })
        updateXarrow()
    }

    const updateXarrow = useXarrow();

    const Rotater = (rotateAngle) => {
        setresize({ ...resize, rotateAngle: rotateAngle })
        updateXarrow()
    }

    const handleResize = ({ top, left, width, height }, isShiftKey, type) => {
        setresize({
            width: Math.round(width),
            height: Math.round(height),
            left: parseInt(Math.round(left)),
            top: parseInt(Math.round(top)),
            rotateAngle: resize.rotateAngle
        })
        updateXarrow()
    }

    const handleUp = async () => {
        const newArray = Array.from(boxdata);

        for (var i = 0; i < newArray.length; i++) {
            if (newArray[i].key === box.key) {
                newArray[i].x = resize.left;
                newArray[i].y = resize.top;
                newArray[i].width = resize.width;
                newArray[i].height = resize.height;
                newArray[i].rotateAngle = resize.rotateAngle;
                break;
            }
        }
        setboxdata(newArray);
        updateXarrow();
    }

    return (<>
        <div id={id}
            style={{
                position: 'absolute', width: resize.width, height: resize.height, left: resize.left, top: resize.top, transform: `rotate(${resize.rotateAngle}deg)`
            }}
        >
            {boxdata[0].type == 'Character' && (
                <ResizableRect
                    rotatable={true}
                    top={resize.top}
                    left={resize.left}
                    width={resize.width}
                    height={resize.height}
                    aspectRatio={resize.width / resize.height}
                    zoomable={'nw, ne, se, sw'}
                    onResizeEnd={handleUp}
                    onResize={handleResize}
                    rotateAngle={resize.rotateAngle}
                    onRotate={Rotater}
                    onRotateEnd={handleUp}
                    onDrag={Drag}
                    onDragEnd={handleUp}
                />
            )}
            {boxdata[0].type != 'Character' && (
                <ResizableRect
                    rotatable={true}
                    top={resize.top}
                    left={resize.left}
                    width={resize.width}
                    height={resize.height}
                    zoomable={'n, w, s, e, nw, ne, se, sw'}
                    onResizeEnd={handleUp}
                    onResize={handleResize}
                    rotateAngle={resize.rotateAngle}
                    onRotate={Rotater}
                    onRotateEnd={handleUp}
                    onDrag={Drag}
                    onDragEnd={handleUp}
                />
            )}
            <div className={"RectBorder DivTag"} draggable={false} style={{ zIndex: '-1' }} >
                <img className="ImgTag"
                    style={{
                        transform: data.flip,
                        opacity: data.opacity
                    }}
                    draggable={false}
                    src={data.ImageSrc}
                />
            </div>
        </div>
    </>);
};

export default CanvasOverlay;

